import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Grid } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";

export default function PanelHeader({children, header, justify}) {
    return (
        <div className="fluid content-panel-header"
            style={{display: "flex", gap: "1rem", justifyContent: justify, alignItems: "center"}}
        >
            {children}
        </div>
    )
}